import React, { FunctionComponent, useEffect } from 'react'
import {
  Text,
  StyleSheet,
  View
} from 'react-native'
import { TextInput } from 'react-native-gesture-handler'
import stylesheet from './Style'

const MyTextarea = (props) => {
  const css = stylesheet();
  
  const [input, setInput] = React.useState(null);
  const [text, setText] = React.useState('');
  const [focus, setFocus] = React.useState(false);
  
  return (
      <TextInput 
        inputMode={props.inputMode}
        keyboardType={props.keyboardType}
        multiline={true}
        numberOfLines={10}
        placeholder={props.isInfo?'':props.placeholder}
        onChangeText={props.onChangeText}
        value={props.value}
        editable={props.isInfo?false:props.editable}
        style={
            [
              css.s,
              {
                  borderWidth: props.isInfo?0:1,
                  height: 99,
                  minHeight: 99,
                  maxHeight: 99,
                  borderColor: '#bdbdbd',
                  borderRadius: props.isInfo?0:8,
                  overflow: 'hidden',
                  width: '100%',
                  padding: props.isInfo?0:7,
                  fontFamily: 'Comfortaa-Regular',
                  color: '#474747',
                  textAlignVertical: 'top',
                  outline: 0
              },
              props.style
            ]
        }
      />
  )
}
const styles = StyleSheet.create({
})
export default MyTextarea